import React from "react";

import Layer1 from "../layers/Layer1"
import Layer2 from "../layers/Layer2"
import ScheduleEditor from "../layers/Layer3/ScheduleEditor"
import Layer4 from "../layers/Layer4"
import useGlobal from "../store";

import "./index.scss";

const ScheduleModule = () => {
    let [currentState, currentActions] = useGlobal();

    return  (
        <div className="ui-main location">
            <Layer1 />
            <Layer2 submodule="Schedules" context="Schedules"/>
            <ScheduleEditor />
            <Layer4 />
        </div>
    )
}

export default ScheduleModule